import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { palette } from 'theme';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const LabelTypography = styled(Typography)`
  color: ${palette.grey[300]};
  margin-right: 30px;
`;
const QuestionTypography = styled(Typography)`
  margin-bottom: 15px;
`;
const AnswerTypography = styled(Typography)`
  font-weight: 400;
  font-style: italic;
  margin-bottom: 15px;
`;

const QAGrid = styled(Grid)`
  padding: ${props => (props.small ? '15px' : '30px')} 0;
  ${props =>
    props.small &&
    css`
      ${LabelTypography} {
        font-size: 28px;
        margin-right: 15px;
      }
      ${QuestionTypography} {
        font-size: 16px;
      }
      ${AnswerTypography} {
        font-size: 16px;
      }
    `}
`;

const ApplicationQA = ({ question, answer, small }) => (
  <QAGrid container align="left" small={small ? 1 : 0}>
    <Grid item xs="auto">
      <LabelTypography variant="h3">Q:</LabelTypography>
    </Grid>
    <Grid item xs={10}>
      <QuestionTypography variant="h4">{question}</QuestionTypography>
    </Grid>
    <Grid item xs={12} />
    <Grid item xs="auto">
      <LabelTypography variant="h3">A:</LabelTypography>
    </Grid>
    <Grid item xs={10}>
      <AnswerTypography variant="h4">{answer}</AnswerTypography>
    </Grid>
  </QAGrid>
);

ApplicationQA.propTypes = {
  question: PropTypes.string,
  answer: PropTypes.string,
  small: PropTypes.bool
};

export default ApplicationQA;
